// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3n7Qd","approved":"Status_approved__1q6Xs","rejected":"Status_rejected__1M3t6","expired":"Status_expired__2d-ij","label":"Status_label__1vZn4"};